import { borderTypes, sizeVariantValues } from "@insite/mobius/FormField/formStyles";
import { formFieldBorderTypes, formFieldSizeVariants } from "@store/theme/props/form";
import merge from "lodash/merge";

merge(sizeVariantValues, formFieldSizeVariants);
merge(borderTypes, formFieldBorderTypes);
